import imgOne from "../../assets/images/information/shehroze4.jpg";
import imgTwo from "../../assets/images/gallery/galleryImg24.JPG";
import imgThree from "../../assets/images/gallery/galleryImg25.JPG";
import imgFour from "../../assets/images/gallery/galleryImg26.JPG";

export default function ThreePosterSections() {
  return (
    <section className="bg-[#0e202b]/95 text-white">

      {/* ========== SECTION 1 ========== */}
      <div className="relative h-screen grid grid-cols-1 lg:grid-cols-2 overflow-hidden">

        {/* IMAGE */}
        <div className="relative">
          <img
            src={imgOne}
            alt="Documentary portrait"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/20" />
        </div>

        {/* TEXT */}
        <div className="relative flex items-center px-8 lg:px-20">
          <div>
            <p className="uppercase tracking-widest text-sm text-gray-400 mb-6">
              Captured Reality
            </p>

            <h2 className="text-[12vw] lg:text-[8vw] leading-[0.85] font-extrabold">
              RAW
              <br />
              EMOTION
            </h2>

            <p className="mt-6 max-w-md text-gray-300">
              Unfiltered expressions captured in moments where
              silence speaks louder than words.
            </p>
          </div>
        </div>
      </div>

      {/* ========== SECTION 2 ========== */}
      <div className="relative h-screen grid grid-cols-1 lg:grid-cols-2 overflow-hidden">

        {/* TEXT */}
        <div className="relative flex items-center px-8 lg:px-20 order-2 lg:order-1">
          <div>
            <p className="uppercase tracking-widest text-sm text-gray-400 mb-6">
              A Turning Point
            </p>
            <h2 className="text-[11vw] lg:text-[7vw] leading-[0.9] font-extrabold">
              ONE
              <br />
              DAY
            </h2>

            <p className="mt-6 max-w-md text-gray-400">
              Every frame holds a decision.
              Every day changes the story.
            </p>
          </div>
        </div>

        {/* IMAGE */}
        <div className="relative order-1 lg:order-2">
          <img
            src={imgTwo}
            alt="Black and white portrait"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/30" />
        </div>
      </div>

      {/* ========== SECTION 3 ========== */}
      <div className="relative h-screen grid grid-cols-1 lg:grid-cols-2 overflow-hidden">

        {/* IMAGE */}
        <div className="relative">
          <img
            src={imgThree}
            alt="Split face portrait"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/40" />
        </div>

        {/* TEXT */}
        <div className="relative flex items-center px-8 lg:px-20">
          <div>
             <p className="uppercase tracking-widest text-sm text-gray-400 mb-6">
              Breaking Barriers
            </p>
            <h2 className="text-[10vw] lg:text-[6vw] leading-[0.9] font-extrabold">
              BEYOND
              <br />
              LIMITS
            </h2>

            <p className="mt-6 max-w-md text-gray-300">
              Pushing past comfort, identity, and expectation, the story begins where boundaries end.
            </p>
          </div>
        </div>
      </div>

      {/* ========== SECTION 4 (NEW) ========== */}
      <div className="relative h-screen grid grid-cols-1 lg:grid-cols-2 overflow-hidden">

        {/* TEXT */}
        <div className="relative flex items-center px-8 lg:px-20 order-2 lg:order-1">
          <div>
            <p className="uppercase tracking-widest text-sm text-gray-400 mb-6">
              The Aftermath
            </p>

            <h2 className="text-[10vw] lg:text-[6vw] leading-[0.9] font-extrabold">
              ABOVE 
              <br />
              ALL LIMITS
            </h2>

            <p className="mt-6 max-w-md text-gray-300">
              What remains after the climb is not just memory,
              but transformation etched into who we become.
            </p>
          </div>
        </div>

        {/* IMAGE */}
        <div className="relative order-1 lg:order-2">
          <img
            src={imgFour}
            alt="Journey reflection"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/35" />
        </div>
      </div>

    </section>
  );
}
